import {
  useCachedTargetAudience,
  useCachedGeographicFocus,
  useCachedBusinessName,
  useCachedBusinessAddress,
} from 'hooks';

export const useInfoCompletenessScore = () => {
  const { targetAudience } = useCachedTargetAudience();
  const { geographicFocus } = useCachedGeographicFocus();
  const { businessName } = useCachedBusinessName();
  const { businessAddress } = useCachedBusinessAddress();

  const infoCompletenessScore =
    (businessAddress?.final_score || 0) * 0.15 +
    (businessName?.final_score || 0) * 0.15 +
    (targetAudience?.company_analysis?.final_score || 0) * 0.35 +
    (geographicFocus?.company_analysis?.final_score || 0) * 0.35;

  return { infoCompletenessScore };
};
